import ConfigurableListValuePicker from './ConfigurableListValuePicker'

export default ConfigurableListValuePicker
